import Ajax from 'global/od/Ajax';

export const addToCart = (data = {}) =>
	Ajax({
		url: '/ajax/cart/checkandaddtocart',
		method: 'POST',
		dataType: 'html',
		data,
	});

export default addToCart;
